import { styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';

export const AdminDialogButton = styled(LoadingButton)(() => ({
    width: "210px",
    height: "40px",
    fontSize: "20px",
    lineHeight: "25px",
    borderRadius: "10px",
    textTransform: "none"
}));